import { ngOpenDialog } from '../popups'

/**
 * Сервис для работы с диалоговыми окнами.
 * @ngInject
 */
export default class PopupService {
  constructor($state) {
    this.$state = $state
  }

  /**
   * Открытие состояния в диалоговом окне.
   *
   * @param {string} matcher URL-матчер
   * @param {object} params параметры состояния
   * @param {number} width длина окна (px)
   * @param {number} height высота окна (px)
   * @returns {Promise<object>} результат выхода из диалога
   */
  state(matcher, params = {}, width = 1024, height = 768) {
    const url = this.$state.href(matcher, params)
    if (url === null) {
      throw new Error(`Invalid state: ${matcher}, ${params}`)
    }
    return ngOpenDialog(url.slice(3), width, height)
  }
}
